  import React from 'react'
  import Layout from '../../components/App/Layout'
  import Navbar from '../../components/App/NavbarRV'
  import Footer from '../../components/App/FooterRV'
  import KDPImagePage from '../../assets/images/pages/3-0-0-0.jpg'
  
  const Details = () => {
      return (
          <Layout>
              <Navbar />
              <div>
                  <div className='container'>
                      <div className='page-title-content'>
                          <ul>
<li><a href='/'>Accueil</a></li><li>Trouvez un expert près de chez vous</li>
                          </ul>
                      </div>
                  </div>
              </div>
              <section className="services-details-area ptb-100">
                  <div className="container">
                      <div className="row">
                          <div className="col-lg-8 col-md-12">
                              <div className="services-details-desc">
                                
<h1>Un besoin d’expertise ? Retrouvez notre cabinet d’expertise près de chez vous</h1>

<p>Le Cabinet RV EXPERTISES intervient pour vos problématiques expertales sur toute la région PACA ainsi que dans le Gard et L’Hérault.</p>
<div className='services-details-image'>
  <img src={KDPImagePage} alt="Trouvez un expert près de chez vous" />
</div>

<p>Retrouvez également nos collaborateurs à Saint Etienne et Lyon.</p>

<p>Définissez avec notre expert votre besoin d’expertise dans un des domaines suivants :</p>

<ul><li>avis technique avant acquisition,</li>
<li>expertise fissure sur ouvrage,</li>
<li>assistance à la réception et livraison VEFA et CCMI,</li>
<li>expertise malfaçon,</li>
<li>vices cachés et DOL,</li>
<li>recours amiable,</li>
<li>assistance après sinistre sécheresse,</li></ul>

<h2>Une équipe d’experts au service de l’assuré</h2>

<h1>Le cabinet RV Expertises s’est développé autour d’une idée forte : accompagner techniquement et défendre les intérêts de l’assuré sinistré.</h1>
<p>C’est pourquoi nous mettons en place systématiquement un protocole strict pour la réalisation de nos expertises, afin de vous proposer une expertise personnalisée et adaptée à vos besoins.</p>

<p>Le monde de l'expertise est vaste et pluridisciplinaire. Plusieurs compétences et qualités doivent être requises. Le cabinet RV Expertises s’engage sur ces qualités pour mener à bien une expertise adaptée à vos besoins :</p>

<ul><li>celle de l’écoute du client pour ses besoins</li>
<li>la rigueur dans l’analyse et la démonstration argumentaire,</li>
<li>les connaissances techniques du bâti et des pathologies de la construction,</li>
<li>le déroulement et la tenue des contre-expertises.</li></ul>

<p>Pour toute demande d’expertise, veuillez remplir le formulaire contact en nous précisant votre besoin et vos attentes, nous vous répondrons dans les 48 heures suivant la réception de votre message.</p>


<p> </p>
<div className="others-option d-flex align-items-center">
    <div className="option-item">
        <a class="default-btn" href="/contact/"><i className="flaticon-right"></i> Contacter le cabinet RV Expertises</a>
    </div>
</div>




                                
                              </div>
                          </div>
                          <div className="col-lg-4 col-md-12">
                              <div className="services-details-info">
                                  <ul className="services-list">
                                      
<li><a href='/paca/' className='active'>Trouvez un expert près de chez vous</a></li><li><a href='/paca/expert-batiment-provence-alpes-cote-azur/' >Expert batiment Provence-Alpes-Côte d'Azur</a></li><li><a href='/paca/expert-batiment-bouche-rhone/' >Expert batiment Bouches-du-Rhône</a></li><li><a href='/paca/expert-batiment-aix-en-provence/' >Expert batiment Aix en provence</a></li><li><a href='/paca/expert-batiment-proche-aix-en-provence/' >Expert Bâtiment et Construction Aix-en-Provence et environs</a></li><li><a href='/paca/expert-batiment-marseille/' >Expert batiment Marseille</a></li><li><a href='/paca/expert-batiment-salon-de-provence/' >Expert batiment Salon de Provence</a></li><li><a href='/paca/expert-batiment-avignon/' >Expert batiment Avignon</a></li><li><a href='/paca/expert-fissure-provence-alpes-cote-azur/' >Expert fissure Provence-Alpes-Côte d'Azur</a></li><li><a href='/paca/expert-fissure-bouche-rhone/' >Expert fissure Bouches-du-Rhône</a></li><li><a href='/paca/expert-fissure-aix-en-provence/' >Expert fissure Aix en provence</a></li><li><a href='/paca/expert-fissure-environ-aix-en-provence/' >Expert fissure Aix-en-Provence et environs</a></li><li><a href='/paca/expert-fissure-marseille/' >Expert fissure Marseille</a></li><li><a href='/paca/expert-fissure-salon-de-provence/' >Expert fissure Salon de Provence</a></li><li><a href='/paca/expert-fissure-avignon/' >Expert fissure Avignon</a></li><li><a href='/paca/expert-humidite-provence-alpes-cote-azur/' >Expert humidité Provence-Alpes-Côte d'Azur</a></li><li><a href='/paca/expert-humidite-bouche-rhone/' >Expert humidité Bouches-du-Rhône</a></li><li><a href='/paca/expert-humidite-aix-en-provence/' >Expert humidité Aix en provence</a></li><li><a href='/paca/expert-humidite-environ-aix-en-provence/' >Expert humidité Aix-en-Provence et environs</a></li><li><a href='/paca/expert-humidite-marseille/' >Expert humidité Marseille</a></li><li><a href='/paca/expert-humidite-salon-de-provence/' >Expert humidité Salon de Provence</a></li><li><a href='/paca/expert-humidite-avignon/' >Expert humidité Avignon</a></li><li><a href='/paca/expert-inondation-provence-alpes-cote-azur/' >Expert inondation Provence-Alpes-Côte d'Azur</a></li><li><a href='/paca/expert-inondation-bouche-rhone/' >Expert inondation Bouches-du-Rhône</a></li><li><a href='/paca/expert-inondation-aix-en-provence/' >Expert inondation Aix en provence</a></li><li><a href='/paca/expert-inondation-marseille/' >Expert inondation Marseille</a></li><li><a href='/paca/expert-secheresse-provence-alpes-cote-azur/' >Expert sécheresse Provence-Alpes-Côte d'Azur</a></li><li><a href='/paca/expert-secheresse-bouche-rhone/' >Expert sécheresse Bouches-du-Rhône</a></li><li><a href='/paca/expert-secheresse-aix-en-provence/' >Expert sécheresse Aix en provence</a></li><li><a href='/paca/expert-secheresse-environ-aix-en-provence/' >Expert sécheresse X pages par ville à 100 km autour d'Aix</a></li><li><a href='/paca/expert-secheresse-marseille/' >Expert sécheresse Marseille</a></li><li><a href='/paca/expert-secheresse-salon-de-provence/' >Expert sécheresse Salon de Provence</a></li><li><a href='/paca/expert-secheresse-avignon/' >Expert sécheresse Avignon</a></li>
                                      
                                  </ul>
                                  <a href='javascript:history.go(-1)'>Retour</a>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
              <Footer />
          </Layout>
      );
  }

  export default Details